import { Icon } from "@iconify/react";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function AppointmentForm() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedPoliklinik, setSelectedPoliklinik] = useState("");
  const [selectedPembayaran, setSelectedPembayaran] = useState("");
  const [nama, setNama] = useState("");
  const [nik, setNik] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedDate = selectedDate
      ? `${selectedDate.getDate()}/${
          selectedDate.getMonth() + 1
        }/${selectedDate.getFullYear()}`
      : "";
    const message = `Hallo RS Mutiara Bunda%0a%0aPendaftaran untuk:%0aNama: ${nama}%0aNIK / No RM: ${nik}%0aPoliklinik: ${selectedPoliklinik}%0aTanggal: ${formattedDate}%0aPembayaran: ${selectedPembayaran}%0aTerimakasih`;
    const phoneNumber = "6281369167220"; // Ganti dengan nomor WhatsApp tujuan
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <form action="#" className="row" onSubmit={handleSubmit}>
      <div className="col-lg-12">
        <label className="cs_input_label cs_heading_color">Nama</label>
        <input
          type="text"
          className="cs_form_field"
          placeholder=""
          value={nama}
          onChange={(e) => setNama(e.target.value)}
        />
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">NIK / No RM</label>
        <input
          type="text"
          className="cs_form_field"
          placeholder=""
          value={nik}
          onChange={(e) => setNik(e.target.value)}
        />
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">Poliklinik</label>
        <select
          className="cs_form_field"
          value={selectedPoliklinik}
          onChange={(e) => setSelectedPoliklinik(e.target.value)}
        >
          <option value="">Pilih Poliklinik</option>
          <option value="Poli Anak">Poliklinik Anak</option>
          <option value="Poli Bedah">Poliklinik Bedah</option>
          <option value="Poli Gigi">Poliklinik Gigi</option>
          <option value="Poli Kandungan">Poliklinik Kandungan</option>
          <option value="Poli Kulit & Kelamin">
            Poliklinik Kulit & Kelamin
          </option>
          <option value="Poli Penyakit Dalam">Poliklinik Penyakit Dalam</option>
          <option value="THT-KL"> THT-KL</option>
          <option value="Poli Saraf">Poliklinik Saraf</option>
          <option value="Radiologi">Radiologi</option>
          <option value="Fisioterapi">Fisioterapi</option>
        </select>
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">Tanggal</label>
        <div className="cs_with_icon_input">
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="dd/MM/yyyy"
            minDate={new Date()}
            isClearable
            placeholderText="dd/mm/yyyy"
          />
        </div>
        <div className="cs_height_42 cs_height_xl_25" />
      </div>
      <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">Pembayaran</label>
        <select
          className="cs_form_field"
          value={selectedPembayaran}
          onChange={(e) => setSelectedPembayaran(e.target.value)}
        >
          <option value="">Pilih Pembayaran</option>
          <option value="umum">Umum</option>
          <option value="bpjs">BPJS</option>
          <option value="asuransi">Asuransi</option>
        </select>
        <div className="cs_height_42 cs_height_xl_25" />
      </div>

      <div className="col-lg-12">
        <button className="cs_btn cs_style_1" type="submit">
          <span>Buat Janji Temu</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </button>
      </div>
    </form>
  );
}
